/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, SimpleChanges } from '@angular/core';
import { IDialogMessage, RESULT_BASE } from './ami-dialog-message.interface';

@Component({
  selector: 'ami-dialog-message',
  templateUrl: './ami-dialog-message.component.html',
  styleUrls: ['../../../../assets/demo/badges.scss']
})
export class AmiDialogMessageComponent {
  @Input() setting: IDialogMessage;
  isResult = RESULT_BASE;
  visible = false;
  isProcessing = false;
  textColor: string;
  message: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.resetMessages();
    const currentValue = changes.setting?.currentValue;
    const status = currentValue?.status;
    const message = currentValue?.message;
    if (!status && message) {
      this.isProcessing = true;
      this.message = currentValue?.message;
    }
    if (status && message) {
      this.message = currentValue.message;
      this.setTypeMessage(status);
    }
    if (status === 0 && !message) {
      this.isResult.serverError = true;
      this.message = 'El servicio no esta disponible, intente más tarde.';
    }
    this.visible = this.message ? true : false;
  }

  resetMessages() {
    this.isProcessing = false;
    this.isResult = { ...RESULT_BASE };
  }

  setTypeMessage(status: number) {
    if (status >= 100 && status < 200) {
      this.textColor = 'text-info';
      this.isResult.information = true;
    } else if (status >= 200 && status < 300) {
      this.textColor = 'text-success';
      this.isResult.success = true;
    } else if (status >= 300 && status < 400) {
      this.textColor = 'text-warning';
      this.isResult.redirection = true;
    } else if (status >= 400 && status < 500) {
      this.textColor = 'text-info';
      this.isResult.clientError = true;
    } else if (status >= 500) {
      this.textColor = 'text-danger';
      this.isResult.serverError = true;
      this.message = 'Error en el servicio, intente más tarde.';
    }
  }
}
